/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcels200,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcels401,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcels500,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcelsPathParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcelsQueryParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcelsQueryResponse,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcels.ts";
import { ePaymentMethodSchema } from "../ePaymentMethodSchema.ts";

export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcelsPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcelsPathParams>;

export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcelsQueryParamsSchema =
  z
    .object({
      originalNumberParcels: z.optional(z.coerce.number().int()),
      newPaymentMethod: z.optional(
        z
          .lazy(() => ePaymentMethodSchema)
          .describe(
            "1 = Billet | 2 = CreditCardAprovaFacil | 3 = CreditCardMundiPagg | 4 = BankDeposit | 5 = CreditCardStripe | 6 = BilletPecegePay | 7 = CreditCardPecegePay | ",
          ),
      ),
    })
    .optional() as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcelsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcels200Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcels200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcels401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcels401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcels500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcels500>;

export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcelsQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcels200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidCheckNumberParcelsQueryResponse>;
